export const updateLocal = (data) => {
  localStorage.setItem("user_settings", JSON.stringify(data));
};
